import { Translate } from "@omni/types/utils/translate";
import React, { Context, use } from "react";
import { useSelector } from "react-redux";

import { translateKey } from "@/redux/modules/value/translations/translations.helpers";
import {
    getTranslations,
    getTranslationsDebug
} from "@/redux/modules/value/translations/translations.selector";
import memoize from "@/utils/memoize";

export type GraniteContextValues = {
    t: Translate;
};

const defaultContext: GraniteContextValues = {
    t: () => ""
};

export const GraniteContext: Context<GraniteContextValues> =
    React.createContext<GraniteContextValues>(defaultContext);

export type GraniteProviderProps = {
    children?: React.ReactNode;
};

const GraniteProvider = ({ children }: GraniteProviderProps) => {
    const translations = useSelector(getTranslations);
    const debug = useSelector(getTranslationsDebug);

    const translate = (
        key: string,
        ...params: Array<string | number | undefined>
    ): string => {
        const TK = translateKey(translations, key, params);
        if (!TK && debug) {
            return key;
        }

        return TK;
    };

    const memoTranslate = memoize(translate, { vargs: true });

    return (
        <GraniteContext value={{ t: memoTranslate }}>{children}</GraniteContext>
    );
};

const useGranite = (): GraniteContextValues => {
    const context = use<GraniteContextValues>(GraniteContext);
    if (context === undefined) {
        throw new Error("useGraniteContext is undefined.");
    }
    return context;
};

export { GraniteProvider, useGranite };
